import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const Rezervace: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Rezervace | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Zamluvte si termín ubytování nebo akce v Hospůdce pod Rablinů. Rychlá rezervace na pár kliknutí."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLACE) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= HERO ================= */}
        <section className="flex flex-col items-center text-center pt-28 pb-16 px-6">
          <img
            src="./img/obrazek-hpr-2.png"
            alt="Hospůdka pod Rablinů"
            className="w-24 mb-6"
          />

          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            Zamluvte si termín
          </h1>

          <p className="text-sm md:text-base mt-2 font-serif">
            Na pár kliknutí
          </p>
        </section>

        {/* ================= TLAČÍTKA ================= */}
        <section className="flex flex-col items-center gap-6 py-10">

          <Link
            to="/rezervace-ubytovani"
            className="
              w-72
              bg-white
              border
              border-gray-300
              rounded-xl
              py-4
              text-center
              font-serif
              text-lg
              hover:shadow-md
              transition
            "
          >
            Rezervace <strong>pokoje</strong>
          </Link>

          <Link
            to="/rezervace-akce"
            className="
              w-72
              bg-white
              border
              border-gray-300
              rounded-xl
              py-4
              text-center
              font-serif
              text-lg
              hover:shadow-md
              transition
            "
          >
            Rezervace <strong>akcí</strong>
          </Link>

        </section>

        {/* ================= PODMÍNKY ================= */}
        <section className="max-w-3xl mx-auto px-6 py-16 space-y-8 text-sm md:text-base">

          <h2 className="font-serif text-lg underline">
            Všeobecné podmínky rezervace
          </h2>

          <p className="leading-relaxed">
            Rezervaci pokoje je nutné provést{" "}
            <strong>minimálně 24 hodin před</strong>{" "}
            plánovaným příjezdem. Pokud rezervace není provedena včas,
            prosíme o osobní, telefonický nebo e-mailový kontakt
            pro domluvu alternativního řešení.
          </p>

          <p className="leading-relaxed">
            Rezervace akcí a firemních setkání musí být provedena{" "}
            <strong>minimálně 7 pracovních dní před</strong>{" "}
            plánovaným termínem. V případě pozdní rezervace nás kontaktujte
            osobně, telefonicky nebo e-mailem – odpovíme do 24 hodin.
          </p>

        </section>

        {/* ================= FOOTER COPYRIGHT ================= */}
        <section className="bg-white py-6 text-center text-xs font-serif">
          © 2020 – 2026 GAMPERIOS s.r.o.
        </section>

        {/* ================= FOOTER (RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default Rezervace;